import React from 'react';

import { Translate, NotificationBanner } from '@hydra/common/components';
import { useI18n } from '@hydra/common/customHooks';

function GoogleAnalyticsErrorBanner ({
  gaError,
  url
}: {
  gaError: string
  url: string
}) {
  const { locale } = useI18n();
  let title;
  let description;

  if (gaError === 'invalidGrant') {
    title = <Translate content='google_analytics_invalid_grant_error_title' />;
    description = <Translate content='google_analytics_invalid_grant_error_description' with={{ url: `/${locale}/settings/${url}` }} />;
  } else if (gaError === 'quotaError') {
    title = <Translate content='google_analytics_quota_error_title' />;
    description = <Translate content='google_analytics_quota_error_description' />;
  } else {
    title = <Translate content='google_analytics_unknown_error_title' />;
    description = <Translate content='google_analytics_unknown_error_description' />;
  }

  return (
    <NotificationBanner
      severity='error'
      variant='outlined'
      dismissable
      title={title}
      description={description}
    />
  );
}

export default GoogleAnalyticsErrorBanner;
